
<div>
  <dl class="govuk-summary-list">
    <div class="govuk-summary-list__row">
      <dt class="govuk-summary-list__key">Id</dt>
      <dd class="govuk-summary-list__value">{{job.id}}</dd>
    </div>
    @if (job.processDefinitionId) {
      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key"> Process definition </dt>
        <dd class="govuk-summary-list__value"> {{job.processDefinitionId}} </dd>
      </div>
    }
    @if (job.processInstanceId) {
      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Process instance</dt>
        <dd class="govuk-summary-list__value"> {{job.processInstanceId}} </dd>
      </div>
    }
    @if (job.executionId) {
      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Execution id</dt>
        <dd class="govuk-summary-list__value"> {{job.executionId}} </dd>
      </div>
    }
    @if (job.retries) {
      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Retries</dt>
        <dd class="govuk-summary-list__value"> {{job.retries}} </dd>
      </div>
    }
    @if (job.exceptionMessage) {
      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Exception</dt>
        <dd class="govuk-summary-list__value"> {{job.exceptionMessage}} </dd>
      </div>
    }
    @if (job.stackTrace) {
      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Stack trace</dt>
        <dd class="govuk-summary-list__value"><pre> {{job.stackTrace}} </pre></dd>
      </div>
    }
  </dl>

  <button class="govuk-button" data-module="govuk-button" [routerLink]="['/jobs']">
    Back to list
  </button>
</div>
